import type { IsOrganizationInstancePageParams } from '../types';

const isOrganizationInstancePage = ({ pathname }: IsOrganizationInstancePageParams): boolean =>
    /\/services\/[^/]+/.test(pathname);

export default isOrganizationInstancePage;
